import { type DependencyList, useEffect, useRef } from 'react';

const useUpdateEffect = (
  fn: () => void,
  deps: DependencyList = [],
  enabled: boolean | undefined = undefined
): void => {
  const fnRef = useRef(fn);
  const loadedRef = useRef(enabled === undefined ? false : enabled);

  useEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  useEffect(() => {
    if (loadedRef.current) fnRef.current();
    // biome-ignore lint/correctness/useExhaustiveDependencies: deps array is intentionally controlled by caller
  }, deps);

  useEffect(() => {
    loadedRef.current = enabled === undefined ? true : enabled;
  }, [enabled]);
};

export default useUpdateEffect;
